import React, { type ComponentType } from 'react';
import {
	PageLayout,
	type PageLayoutProps,
} from '@jira/design-system__navigation-system/src/PageLayout.tsx';
import { IsFhsEnabledProvider } from '@atlaskit/navigation-system/fhs-rollout';
import { fg } from '@atlassian/jira-feature-gating';

export const JiraPageLayout: ComponentType<PageLayoutProps> = ({
	children,
	...props
}: PageLayoutProps) => (
	<IsFhsEnabledProvider value={false}>
		<PageLayout {...props} isSideNavShortcutEnabled={fg('platform-dst-keep-desired-fhs-features')}>
			{children}
		</PageLayout>
	</IsFhsEnabledProvider>
);
